var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapLocation(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 91 91"
    },
    viewBox: "0 0 91 91",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.5,54.6H43.6v-5.7h22.9c0.9,0,1.7-0.8,1.7-1.7V36.4c0-0.9-0.8-1.7-1.7-1.7h-7.6v-5.1c1.9-2.3,4.8-6,4.8-8.4 c0-3.6-2.9-6.5-6.5-6.5c-3.6,0-6.5,2.9-6.5,6.5c0,2.4,2.9,6.2,4.8,8.4v6.8c0,0.9,0.8,1.7,1.7,1.7h7.6v7.5H41.9 c-0.9,0-1.7,0.8-1.7,1.7v9.1c0,0.9,0.8,1.7,1.7,1.7h30.9v8H26.4v-4.3c2.8-3.2,8.2-9.8,8.2-13.8c0-5.4-4.4-9.9-9.9-9.9 c-5.4,0-9.9,4.4-9.9,9.9c0,4,5.4,10.6,8.2,13.8v6c0,0.9,0.8,1.7,1.7,1.7h49.7c0.9,0,1.7-0.8,1.7-1.7V56.3 C76.1,55.3,75.4,54.6,74.5,54.6z M57.2,19.1c1.2,0,2.1,1,2.1,2.1c0,1.2-1,2.1-2.1,2.1c-1.2,0-2.2-1-2.2-2.1 C55,20.1,56,19.1,57.2,19.1z M21.4,47.6c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4c0,1.9-1.5,3.4-3.4,3.4 C22.9,50.9,21.4,49.4,21.4,47.6z",
    fill: "#cccccc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLocation);
export default __webpack_public_path__ + "static/media/map-location.3235de4e4379844ffccdd6754f5d4da5.svg";
export { ForwardRef as ReactComponent };